
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProgressDashboard from './components/ProgressDashboard';
import AchievementsBadges from './components/AchievementsBadges';
import LearningStats from './components/LearningStats';
import WeeklyGoals from './components/WeeklyGoals';

const ProgressPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <ProgressDashboard />
        <LearningStats />
        <AchievementsBadges />
        <WeeklyGoals />
      </main>
      <Footer />
    </div>
  );
};

export default ProgressPage;
